import {
	COURSEAVAILABLE_BEGIN,
	COURSEAVAILABLE_ADD,
	COURSEAVAILABLE_FAILURE,
	COURSEAVAILABLE_CLEAR,
	SET_COURSEAVAILABLE_USED,
	REMOVE_COURSEAVAILABLE_USED
} from 'app/actions/CourseAvailableActions';

const initialState = {
	courseAvailables: [],
	isLoading: false,
};

export default function CourseAvailableReducer(state = initialState, action) {
	switch (action.type) {
		case COURSEAVAILABLE_BEGIN:
			return {
				...state,
				isLoading: true
			}
		case COURSEAVAILABLE_ADD:
			return {
				...state,
				courseAvailables: action.payload,
				isLoading: false
			};
		case COURSEAVAILABLE_FAILURE:
			return {
				...state,
				isLoading: false
			}
		case COURSEAVAILABLE_CLEAR:
			return {
				...state,
				courseAvailables: [],
				isLoading: false,
			}

		case SET_COURSEAVAILABLE_USED:
			return {
				...state,
				courseAvailables: state.courseAvailables.map(x => x.idCourse === action.payload ? { ...x, assigned: true } : x),
				isLoading: false
			}

		case REMOVE_COURSEAVAILABLE_USED:
			return {
				...state,
				courseAvailables: state.courseAvailables.map(x => x.idCourse === action.payload ? { ...x, assigned: false } : x),
				isLoading: false
			}
		default:
			return state;
	}
};

export const getCourseAvailable = state => {
	return state.allIds.map(id => state.byId[id]);
}